import { createVuetify } from "vuetify"
import "vuetify/styles"
import "@mdi/font/css/materialdesignicons.css"
import * as components from "vuetify/components"
import * as labs from "vuetify/labs/components"
import * as directives from "vuetify/directives"
import { fr } from "vuetify/locale"

export default createVuetify({
    locale: {
        locale: "fr",
        messages: { fr },
    },
    components: { ...components, ...labs },
    directives,
    theme: {
        defaultTheme: "light",
        themes: {
            light: {
                colors: {
                    primary: "#34eb84",
                    secondary: "#b0bec5",
                    error: "#b71c1c",
                },
            },
            dark: {
                dark: true,
                colors: {
                    primary: "#34eb84",
                    secondary: "#b0bec5",
                    error: "#b71c1c",
                },
            },
        },
    },
    icons: {
        defaultSet: "mdi",
    },
})
